import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  toolbarIndentLeft: {
    marginLeft: 22,
  },
  dialogWrapper: {
    display: 'flex',
    width: 800,
  },
}));
